/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { Icons } from '@/components/icons';

// Helper function to get icon based on the unit type and label
export const getIconByUnit = (unit?: string, label?: string): JSX.Element => {
  if (label?.includes('Tokens')) {
    return Icons.BudgetMeasuresIcon();
  }

  switch (unit) {
    case 'Seconds':
      return Icons.LatencyP95Icon();
    case 'Tokens':
      return Icons.BudgetMeasuresIcon();
    case 'Number':
    case 'Count':
    case 'Percentage':
      return Icons.ToolIcon();

    default:
      return Icons.ToolIcon();
  }
};
